import getTLD from "./libs/getTLD";

export const ROLE_ID_USER = 20;
export const ROLE_ID_ADMINISTRATOR = 1;
export const ROLE_ID_STAFF = 10;

export const PROFILE_ITEM = {
  AVATAR: 1,
  ERROR_OMISSION: 2,
  BENEFICIARY: 3,
  COMMISSION_ASSIGNMENT: 4,
  LICENSE: 5,
  CARRIER_APPOINTMENT: 7,
  FIELD_MANUAL: 8,
  DRIVER_LICENSE: 9,
  MEMBERSHIP_AGREEMENT: 10
};

export const COMMISSION_CYCLE_STATUS = {
  APPROVED: "approved",
  CALCULATED: "calculated",
  CALCULATING: "calculating",
  COMPLETED: "completed",
  DRAFT: "draft",
  ERROR_WHILE_CALCULATING: "errored-while-calculating",
  PAYMENT_PENDING: "payment-pending",
  PENDING: "pending"
};

export const PRODUCT_TYPE_ID_ANNUITY = 2;
export const PRIVILEGE_ID_MANAGE_LICENSES = 1;
export const PRIVILEGE_ID_MANAGE_AGENT_LEVELS = 20;
export const PRIVILEGE_ID_MANAGE_PRODUCT_TYPES = 30;
export const PRIVILEGE_ID_MANAGE_CARRIERS = 40;
export const PRIVILEGE_ID_MANAGE_USERS = 50;
export const PRIVILEGE_ID_VIEW_USERS = 51;
export const PRIVILEGE_ID_MANAGE_COMPENSATION_TEMPLATES = 60;
export const PRIVILEGE_ID_MANAGE_COMPENSATION_PLANS = 70;
export const PRIVILEGE_ID_VIEW_COMPENSATION_PLANS = 71;
export const PRIVILEGE_ID_MANAGE_PRODUCTS = 80;
export const PRIVILEGE_ID_MANAGE_FILES = 90;
export const PRIVILEGE_ID_VIEW_FILES = 100;
export const PRIVILEGE_ID_IMPERSONATE = 120;
export const PRIVILEGE_ID_MANAGE_ROLES = 130;
export const PRIVILEGE_ID_VIEW_ERROR_OMISSION = 140;
export const PRIVILEGE_ID_MANAGE_ERROR_OMISSION = 150;
export const PRIVILEGE_ID_MANAGE_DIRECT_DEPOSIT = 190;

export const PRIVILEGE_ID_VIEW_LICENSE_INFO = 210;
export const PRIVILEGE_ID_MANAGE_LICENSE_INFO = 220;
export const PRIVILEGE_ID_MANAGE_LEVEL_HISTORY = 240;
export const PRIVILEGE_ID_VIEW_CARRIER_APPOINTMENT = 250;
export const PRIVILEGE_ID_MANAGE_CARRIER_APPOINTMENT = 260;

export const PRIVILEGE_ID_MANAGE_POLICIES = 270;
export const PRIVILEGE_ID_VIEW_POLICIES = 271;
export const PRIVILEGE_ID_MANAGE_TASKS = 290;
export const PRIVILEGE_ID_VIEW_TASKS = 291;

export const PRIVILEGE_ID_TRANSFER_AGENT = 300;

export const PRIVILEGE_ID_MANAGE_NOTE = 320;

export const PRIVILEGE_ID_MANAGE_EVENTS = 350;

export const PRIVILEGE_ID_MANAGE_COMMISSION = 400;
export const PRIVILEGE_ID_VIEW_OWNED_COMMISSION_STATEMENT = 410;
export const PRIVILEGE_ID_MANAGE_COMMISSION_ADJUSTMENT_CATEGORIES = 420;
export const PRIVILEGE_ID_MANAGE_COMMISSION_ENTRY_CATEGORIES = 450;
export const PRIVILEGE_ID_MANAGE_GROUPS = 480;
export const PRIVILEGE_ID_USE_API_KEYS = 500;
export const PRIVILEGE_ID_MANAGE_PAYMENT_MODE = 560;

export const PRIVILEGE_ID_MANAGE_COMPANY_SETTINGS = 920;

export const NEW_VERSION_CHECK_INTERVAL = 30000;
export const SESSION_TIMEOUT = 3600000;
export const LOG_OUT_SESSION_TIMEOUT = 300000;
export const SESSION_TIMEOUT_ENABLED = false;
export const SYSTEM_MESSAGE = "";
export const KIOSK_SESSION_TIMEOUT = 86400;

export const PRIVILEGE_ID_MANAGE_LINKS = 910;

export const POLICY_STATUS = {
  DRAFT: "draft",
  PENDING: "pending",
  APPROVED: "approved",
  PENDING_DR_APPROVAL: "pending-dr-approval",
  DELIVERED: "delivered",
  PAID: "paid",
  CLIENT_REJECTED: "rejected-by-client",
  CARRIER_DECLINED: "declined-by-carrier",
  CLIENT_CANCELED: "canceled-by-client",
  CARRIER_TERMINATED: "terminated-by-carrier",
  CLOSED: "closed"
};

export const PENDING_PIPELINE_POLICY_STATES = [
  POLICY_STATUS.DRAFT,
  POLICY_STATUS.PENDING_DR_APPROVAL,
  POLICY_STATUS.DELIVERED
];

export const PAID_PIPELINE_POLICY_STATES = [POLICY_STATUS.PAID];
export const FALL_OUT_PIPELINE_POLICY_STATES = [
  POLICY_STATUS.CLIENT_REJECTED,
  POLICY_STATUS.CLIENT_CANCELED,
  POLICY_STATUS.CARRIER_DECLINED,
  POLICY_STATUS.CARRIER_TERMINATED
];

export const SUCCESSFUL_POLICY_STATES = [POLICY_STATUS.PAID, POLICY_STATUS.DELIVERED];

export const TASK_CATEGORY = {
  TASK_CATEGORY_POLICY_ID: 1,
  TASK_CATEGORY_POLICY_NAME: "Policy",
  TASK_CATEGORY_MEMBERSHIP_ID: 2,
  TASK_CATEGORY_MEMBERSHIP_NAME: "Membership",
  TASK_CATEGORY_LICENSE_ID: 3,
  TASK_CATEGORY_LICENSE_NAME: "License",
  TASK_CATEGORY_ERROR_OMISSION_ID: 4,
  TASK_CATEGORY_ERROR_OMISSION_NAME: "Error Omission",
  TASK_CATEGORY_SOFTWARE_ISSUE_ID: 5,
  TASK_CATEGORY_SOFTWARE_ISSUE_NAME: "Software Issue",
  TASK_CATEGORY_PROMOTION_ID: 6,
  TASK_CATEGORY_PROMOTION_NAME: "Promotion",
  TASK_CATEGORY_AGENT_PROFILE_ID: 7,
  TASK_CATEGORY_AGENT_PROFILE_NAME: "Agent Profile",
  TASK_CATEGORY_COMMISSION_ID: 8,
  TASK_CATEGORY_COMMISSION_NAME: "Software Issue",
  TASK_CATEGORY_DIRECT_DEPOSIT_ID: 9,
  TASK_CATEGORY_DIRECT_DEPOSIT_NAME: "Direct Deposit",
  TASK_CATEGORY_APPOINTMENT_ID: 10,
  TASK_CATEGORY_APPOINTMENT_NAME: "Appointment"
};

export const invitationStates = [
  { id: "invited", name: "Invited" },
  { id: "accepted", name: "Accepted" }
];

export const WORKFLOW_CHECKLIST_GET_APPOINTED = {
  AMERICAN_NATIONAL_INSURANCE_COMPANY: "1",
  AMERICAN_INTERNATIONAL_GROUP: "3",
  NATIONAL_LIFE_GROUP: "2",
  ANTI_MONEY_LAUNDERING_REQUIREMENT: "4"
};

export const WORKFLOW = {
  TRAINING_CLASS_REGISTRATION_ID: 3
};
export const DEFAULT_ROOT_PRODUCT_TYPE_ID = 1;

export const SYSTEM_FEATURE_ID_POLICY_COMMISSION_TRACKER = 1;
export const SYSTEM_FEATURE_ID_CLICK_UP_INTEGRATION = 2;
export const SYSTEM_FEATURE_ID_CPA_REPORT = 3;
export const SYSTEM_FEATURE_ID_AISM = 4;
export const SYSTEM_FEATURE_ID_GOOGLE_DRIVE_INTEGRATION = 5;
export const SYSTEM_FEATURE_ID_REQUIRE_DRIVER_LICENSE = 6;
export const SYSTEM_FEATURE_ID_AGENT_CHECKLIST = 7;
export const SYSTEM_FEATURE_ID_REQUIRE_AGENT_EMPLOYMENT_HISTORY = 8;
export const SYSTEM_FEATURE_ID_REQUIRE_AGENT_MEMBERSHIP_AGREEMENT = 11;
export const SYSTEM_FEATURE_ID_TRAINING_CENTER = 12;
export const SYSTEM_FEATURE_ID_PUSH_NOTIFICATION = 13;
export const SYSTEM_FEATURE_ID_LEADERBOARD = 14;
export const SYSTEM_FEATURE_ID_POLICY_LOCK = 16;
export const SYSTEM_FEATURE_ID_MAIL_CHIMP_INTEGRATION = 15;
export const SYSTEM_FEATURE_ID_AGENT_LICENSE = 17;
export const SYSTEM_FEATURE_ID_CERTIFIED_TRAINER = 18;
export const SYSTEM_FEATURE_ID_AGENT_LEVELS = 20;
export const SYSTEM_FEATURE_ID_BUSINESS_AFFILIATIONS = 22;
export const SYSTEM_FEATURE_ID_WORKFLOW_GOVERNMENT_ID = 23;
export const SYSTEM_FEATURE_ID_DIGITAL_TARGET_MARKET_LIST = 24;
export const SYSTEM_FEATURE_ID_COMMITMENT_DASHBOARD = 25;
export const SYSTEM_FEATURE_ID_TRAINING_VIDEO = 27;
export const SYSTEM_FEATURE_ID_AI_GENERATE_SUPPORT = 28;

export const DEFAULT_COOKIE_OPTIONS = {
  sameSite: "strict",
  path: "/",
  domain: getTLD(window.location.hostname)
};

export const EAOP_WORKFLOW_ID = 11;
export const ATRP_WORKFLOW_ID = 9;
export const GOVP_WORKFLOW_ID = 13;
export const LCSP_WORKFLOW_ID = 14;

export const FRONTEND_VERSION_ID_V1 = 1;
export const FRONTEND_VERSION_ID_V2 = 2;

export const CARRIER = {
  AMERICAN_NATIONAL_INSURANCE_COMPANY: 1,
  NATIONAL_LIFE_GROUP: 2,
  AMERICAN_INTERNATIONAL_GROUP: 3,
  OXFORD: 4,
  FGL: 16
};
